import {Injectable} from '@angular/core';
import {FuseAlertType} from "@fuse/components/alert";
import {TranslocoService} from "@ngneat/transloco";
import {HttpErrorResponse} from "@angular/common/http";
import {interval} from "rxjs";
import {AlertType} from "app/core/types/multi.alert.types";

@Injectable({providedIn: 'root'})
export class MultiAlertService {


    protected alerts: AlertType[] = [];
    protected maxNrOfAlerts: number = 10;

    constructor(
        private _translocoService: TranslocoService,
    ) {
    }

    get _alerts() {
        return this.alerts;
    }

    /**
     * Shows message in an alert box. The message will be translated.
     * @param alertType - type fo the alert
     * @param autoCloseTimer - Timer value to autoclose error (seconds). If 0 or less, no auto close timer started. If positive value, timer is started and will autoclose at expiration.
     * @param title - the title to be shown
     * @param msg - a second message to be appended. This is optional.
     * @param placeholderValues - values of placeholders. e.g 'some message~{1};some othermessage@{2}'
     */
    public setAlert(alertType: FuseAlertType, autoCloseTimer: number, title: string, msg: any, placeholderValues?: string): void {
        // Set the alert
        let mainMsgTranslation: string = this._translocoService.translate(title);
        if (msg instanceof HttpErrorResponse) {
            if ('error' in msg && 'message' in msg.error) {
                msg = (msg as HttpErrorResponse).error.message;
            } else {
                msg = (msg as HttpErrorResponse).message
            }
            console.info("Err is", msg);
        }
        let alert: AlertType = {
            type: alertType,
            title: (typeof msg !== "undefined") ? mainMsgTranslation : '',
            message: (typeof msg !== "undefined") ? this._translocoService.translate(msg) : mainMsgTranslation,
            id: -1,
            progress: 0
        }

        //replace placeholders
        if (placeholderValues) {
            const replacementItems: string[] = placeholderValues.split(';');
            replacementItems.forEach(item => {
                const pair = item.split('~');
                if(typeof alert.title.replace === 'function') {
                    alert.title = alert.title.replace(pair[1], pair[0]);
                }
                if(typeof alert.message.replace === 'function') {
                    alert.message = alert.message.replace(pair[1], pair[0]);
                }
            })
        }

        if (this.alerts.length >= this.maxNrOfAlerts) {
            //removing the oldest alert
            console.info("Alert at position 0 was removed as buffer reached limit: ", this.alerts)
            this.alerts.splice(0, 1);
        }

        alert.id = this.genID(alert);

        if (autoCloseTimer > 0) {
            alert.progress = 100;
            this.startTimer(autoCloseTimer, alert);
        }

        //don't show twice same alert
        const alertFound = this.alerts.find(a => a.id === alert.id);
        if (!alertFound) {
            this.alerts.push(alert);
        } else {
            //alert already in buffer
        }
    }

    dismiss(alertID: number) {
        this.alerts.splice(this.alerts.findIndex(alert => alert.id == alertID), 1);
    }

    startTimer(seconds: number, alert: AlertType) {
        const time = seconds;
        let curSec = 0;
        const timer$ = interval(1000);

        const sub = timer$.subscribe((sec) => {
            alert.progress = 100 - sec * 100 / seconds;
            curSec = sec;

            if (curSec === seconds + 2) {
                this.dismiss(alert.id);
                sub.unsubscribe();
            }
        });
    }

    private genID(alert: AlertType): number {
        var input = alert.message + alert.title + alert.type;
        var h: number = 0;
        for (var i = 0; i < input.length; i++) {
            h = 31 * h + input.charCodeAt(i);
        }
        return h;
    }
}



